<template>
  <IMenu placement="bottom-end" width="124">
    <template #link>
      <p :class="$style.label"><SvgIcon :svg="SortSvg" width="13" />{{ label }}</p>
    </template>
    <template #menu>
      <ul :class="$style.menu">
        <li v-for="item in list" :key="item.text" :class="[item.sort === sort && item.order === order && $style.active]">
          <a :href="`?${params}&sort=${item.sort}&order=${item.order}`">{{ item.text }}</a>
        </li>
      </ul>
    </template>
  </IMenu>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import IMenu from '@/js/components/molecules/IMenu.vue';
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import SortSvg from '@/svgs/vue/sort.svg';

const props = defineProps<{
  params: string;
  sort: string;
  order: string;
}>();
const list = [
  {
    sort: 'popular',
    order: 'asc',
    text: '注目順',
  },
  {
    sort: 'listed',
    order: 'desc',
    text: '新着順',
  },
  {
    sort: 'pv',
    order: 'desc',
    text: '閲覧数順',
  },
  {
    sort: 'price',
    order: 'asc',
    text: '価格が安い順',
  },
  {
    sort: 'price',
    order: 'desc',
    text: '価格が高い順',
  },
];
const label = computed(() => list.find((item) => item.sort === props.sort && item.order === props.order)?.text || '');
</script>

<style module lang="scss">
.label > svg {
  margin-right: 6px;
  position: relative;
  top: 1px;
}

.menu {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 6px;

  li {
    &.active {
      font-weight: bold;
    }

    a:hover {
      text-decoration: none;
    }
  }
}
</style>
